//工程设计
import React from 'react';
import './EngineeringDesign.scss';
import { RelatedCases } from '@/components'
import { Lists, HeaderSwiper, ColList } from '@/components/mixins'
class EngineeringDesign extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      navSwiper: '',
      bannerImages: [
        { imgPath: require("img/Products/Engbanner.png"), imgHDPath: `${require("img/Products/Engbanner.png")} 1x,${require("img/Products/Engbanner@2x.png")} 2x,${require("img/Products/Engbanner@3x.png")} 3x`, attachURL: "/" },
      ],
      dataList: [
        {
          title: '项目整体设计和总承包服务',
          data: '以整体设计为理念，为客户提供从项目策划、规划、建筑设计，到园林景观设计及市政道路设计的一站式整体设计和总承包服务，最大限度的为客户节省人力、物力和时间成本，实现高效率高品质。',
          imgPath: require("img/Products/Engpic1.png"), imgHDPath: `${require("img/Products/Engpic1.png")} 1x,${require("img/Products/Engpic1@2x.png")} 2x,${require("img/Products/Engpic1@3x.png")} 3x`
        },
        {
          title: '城乡规划编制',
          data: '帮助客户洞察城乡未来发展价值，综合考虑政治、经济、文化、生态等多项因素，针对项目特色，提供差异化的定制服务，内容包括目标愿景、发展战略、发展方向、技术方案、实施策略等，提供涵盖国土空间规划、控制性详细规划、修建性详细规划、专项规划、城市设计等多种类型的城乡规划专业服务。',
          imgPath: require("img/Products/Engpic2.png"), imgHDPath: `${require("img/Products/Engpic2.png")} 1x,${require("img/Products/Engpic2@2x.png")} 2x,${require("img/Products/Engpic2@3x.png")} 3x`
        },
        {
          title: '风景园林设计',
          data: '以环境友好为目标，以公共空间景观设计、居住区景观设计、旅游度假区与风景名胜区景观设计、城市建设项目景观园林策划、规划与咨询为拓展方向，提供风景园林工程设计全领域的专业服务。',
          imgPath: require("img/Products/Engpic3.png"), imgHDPath: `${require("img/Products/Engpic3.png")} 1x,${require("img/Products/Engpic3@2x.png")} 2x,${require("img/Products/Engpic3@3x.png")} 3x`
        },
        {
          title: '建筑工程设计',
          data: '充分关注客户需求，为客户提供各类公共建筑、居住建筑、商业综合体和工业项目的建设工程设计和咨询、建筑幕墙和照明工程、建筑智能化建设工程、建筑装饰装修工程、消防设施建设工程的设计施工一体化、绿色建筑工程设计咨询与评估等建筑工程全领域的专业工程设计服务。',
          imgPath: require("img/Products/Engpic4.png"), imgHDPath: `${require("img/Products/Engpic4.png")} 1x,${require("img/Products/Engpic4@2x.png")} 2x,${require("img/Products/Engpic4@3x.png")} 3x`
        },
        {
          title: '市政道路设计',
          data: '以完善城市交通功能，美化交通环境为目标，为客户提供兼顾经济效益、社会效益以及良好使用效果的优质作品。',
          imgPath: require("img/Products/Engpic5.png"), imgHDPath: `${require("img/Products/Engpic5.png")} 1x,${require("img/Products/Engpic5@2x.png")} 2x,${require("img/Products/Engpic5@3x.png")} 3x`
        },
        {
          title: '工程设计优化',
          data: '以深厚的工程设计理论为基础，以丰富的实践经验为前提，以对设计规范的理解和灵活运用为指导，以先进、合理的工程设计方法为手段，对工程设计进行优化、改善与提高，对工程造价成本控制进行审核和监控，从而使各项经济、技术指标实现最佳。',
          imgPath: require("img/Products/Engpic6.png"), imgHDPath: `${require("img/Products/Engpic6.png")} 1x,${require("img/Products/Engpic6@2x.png")} 2x,${require("img/Products/Engpic6@3x.png")} 3x`
        }
      ],
      IconData: [
        {
          imgPath: require("img/Products/Engicon1.png"), imgHDPath: `${require("img/Products/Engicon1.png")} 1x,${require("img/Products/Engicon1@2x.png")} 2x,${require("img/Products/Engicon1@3x.png")} 3x`,
          title: '“双甲”和“双乙”资质'
        },
        {
          imgPath: require("img/Products/Engicon2.png"), imgHDPath: `${require("img/Products/Engicon2.png")} 1x,${require("img/Products/Engicon2@2x.png")} 2x,${require("img/Products/Engicon2@3x.png")} 3x`,
          title: '多专业且经验丰富的设计团队'
        },
        {
          imgPath: require("img/Products/Engicon3.png"), imgHDPath: `${require("img/Products/Engicon3.png")} 1x,${require("img/Products/Engicon3@2x.png")} 2x,${require("img/Products/Engicon3@3x.png")} 3x`,
          title: '多方位的创意和品质服务'
        },
        {
          imgPath: require("img/Products/Engicon4.png"), imgHDPath: `${require("img/Products/Engicon4.png")} 1x,${require("img/Products/Engicon4@2x.png")} 2x,${require("img/Products/Engicon4@3x.png")} 3x`,
          title: '多次获得项目设计优秀奖'
        }
      ],
      caseList: [
        // { imgs: require("img/Products/Engxg1.png"), name: "黄花机场后勤基地" },
        // { imgs: require("img/Products/Engxg2.png"), name: "株洲银天广场" },
        // { imgs: require("img/Products/Engxg3.png"), name: "长沙新河三角洲地区" },
        // { imgs: require("img/Products/Engxg4.png"), name: "西湖文化园" },
        // { imgs: require("img/Products/Engxg5.png"), name: "郴州仙岭湖公园" },



        { imgs: require("img/Products/Engxg2.png"), name: "株洲银天广场" },
        { imgs: require("img/Products/Engxg3.png"), name: "长沙新河三角洲地区" },
        { imgs: require("img/Products/Engxg4.png"), name: "西湖文化园" },
        { imgs: require("img/Products/Engxg5.png"), name: "郴州仙岭湖公园" },
        { imgs: require("img/Products/Engxg6.png"), name: "湖南浏阳上云溪·乡居里" },
        { imgs: require("img/Products/Engxg7.png"), name: "湖南娄底薄板深加工产业园" },
        { imgs: require("img/Products/Engxg8.png"), name: "娄底孙水河南岸" },
        { imgs: require("img/Products/Engxg9.png"), name: "武冈市同保山狮子湖景区" },
        // { imgs: require("img/Products/Engxg10.png"), name: "长房宁城府" },
        { imgs: require("img/Products/Engxg11.png"), name: "长沙中烟嘉华城" },
        { imgs: require("img/Products/Engxg12.png"), name: "珠海横琴国际商务综合体" },

      ]

    }

  }
  render() {
    return (<div className='EngineeringDesign' >
      <main className="ContactUs-body">
        <HeaderSwiper headerDataLists={this.state.bannerImages}></HeaderSwiper>
        <div className='EngineeringDesign-count'>
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataList}></Lists>
        </div>
        <div className='EngineeringDesign-advantage'>
          <h5 className='product-title'>服务优势</h5>
          <ColList ColIconData={this.state.IconData}></ColList>
        </div>
        <RelatedCases caseList={this.state.caseList} id={'engineer'} />
      </main>
    </div>
    )
  }
}
export default EngineeringDesign;
